import { uniqBy } from 'lodash';
import ls from '@/helpers/localStorage';
import log from '@/logger';

export const SESSION_HISTORY_EXPIRES_AT = 86400; // 1 day

export const SESSION_HISTORY_SIZE = 10;
export const SESSION_HISTORY_KEY = 'session-history';

const getContractsHistory = () => ls.get(SESSION_HISTORY_KEY, []);
const pushContract = ({ value }) => {
  try {
    const history = getContractsHistory();

    /* append value at the beginning of the list and make sure its unique */
    const newHistory = uniqBy([value, ...history], (el) => el.contractId);
    const result = newHistory.slice(0, SESSION_HISTORY_SIZE);
    ls.set(SESSION_HISTORY_KEY, result, SESSION_HISTORY_EXPIRES_AT);
    return result;
  } catch (error) {
    log.error('Failed to push contract to session history.', error);
    return [];
  }
};

export default {
  pushContract,
  getContractsHistory,
};
